// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__36CXQ","row":"ProcedureTreatmentSummary_row__3rEkU"};